<template>
    <FormulateForm

        v-model="formValues"
        :errors="inputErrors"
        class="login-form mb-3 pb-3 border-bottom"
        @submit="handleSubmit">
        <h2 class="form-title">Galerie hinzufügen</h2>

        <div class="row">
            <FormulateInput
                class="col-12 col-md-6"
                label="Galeriename"
                name="name"
                placeholder="Galeriename"
                type="text"
                validation="required"
                validation-name="Galeriename"/>

            <FormulateInput
                :options="nationalServiceOptions"
                class="col-12 col-md-6"
                help="Hinweis: wählen Sie hier ein Extra aus, wenn Sie wollen, dass diese Galerie bei einem Extra angezeigt wird."
                label="Nationales Extra"
                name="national_service"
                placeholder="Nationales Extra auswählen"
                type="multiselect"
                validation="optional"
                validation-name="Nationales Extra"/>

            <FormulateInput
                class="col-12"
                help="Wählen Sie ein PNG oder JPG zum Hochladen aus..."
                label="Galeriebild hochladen"
                name="image"
                type="image"
                add-label="+ Bilder hinzufügen"
                validation="required|mime:image/jpeg,image/png"
                :validation-messages="{
                    mime: 'Alle Bilder müssen die Endung PNG oder JPG haben.'
                }"
                validation-name="Bild"
                multiple/>
        </div>


        <div class="col-12 d-flex flex-row justify-content-end">
            <div class="btn-group mt-3"
                 role="group">
                <!--            Button Cancel-->
                <button
                    :disabled="isSubmitting"
                    class="btn btn-sm btn-danger"
                    type="button"
                    @click="$emit('cancelNew')">Abbrechen <i class="fas fa-times"></i></button>

                <!--            Button Save -->
                <button
                    :disabled="isSubmitting"
                    class="btn btn-sm btn-success"
                    type="submit">Speichern <i v-if="!isSubmitting" class="fas fa-plus"></i><i
                    v-if="isSubmitting" class="fas fa-spinner fa-spin"></i></button>
            </div>
        </div>
    </FormulateForm>
</template>

<script>
import {cloneDeep} from 'lodash';

export default {
    name: 'GalleryForm',
    props: {
        nationalServiceOptions: Array,
        url: String,
        item: Object,
        axiosMethod: String,
        inputErrors: null,
    },
    data() {
        return {
            formValues: {},
            isSubmitting: false,
        };
    },

    created() {
        if (this.item) {
            this.formValues = cloneDeep(this.item);
        }
    },

    methods: {
        async handleSubmit(formData) {
            this.isSubmitting = true;

            let submitUrl = this.url;

            if (this.item !== undefined && this.item.id !== '') {
                submitUrl = submitUrl + '/' + this.item.id;
            }

            axios({
                method: this.axiosMethod,
                url: submitUrl,
                data: formData,
            }).then((response) => {
                this.$emit('addItem', response.data.validated);
                this.$swal({
                    title: response.data.message,
                });
                this.isSubmitting = false;
            }).catch((error) => {
                this.inputErrors = error.response.data.errors;
                this.$swal({
                    icon: 'error',
                    title: 'Leider ist ein Fehler beim Speichern aufgetreten.',
                });
                this.isSubmitting = false;
            });

        },

        radioChange(index) {
            this.formValues.gallery.forEach((element, elementIndex) => {
                element.thumbnail = elementIndex === index;
            });
        },
    },

    watch: {
        item: {
            deep: true,
            handler() {
                this.formValues = cloneDeep(this.item);
            },
        }
    },
};
</script>

<style scoped>

</style>
